import React, { FC } from "react";

import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Sort } from "@/components/atoms/Sorting/useSort";
import { Table } from "@/components/molecules";
import { RelatedActivitySortProperty } from "@/shared/domain";

import ActivitiesTableItemDesktop from "./ActivitiesTableItemDesktop/ActivitiesTableItemDesktop";
import ActivitiesTableItemMobile from "./ActivitiesTableItemMobile/ActivitiesTableItemMobile";
import { activitiesTableDesktopColumns, activitiesTableMobileColumns } from "./tableColumns";

export type ActivitiesTableProps = {
    activities: MyBrokerApi.Activity[];
    orderBy: Sort<RelatedActivitySortProperty>;
    handleSort: (orderBy: RelatedActivitySortProperty) => void;
    onlySmallTable?: boolean;
};

const ActivitiesTable: FC<ActivitiesTableProps> = ({ activities, handleSort, orderBy, onlySmallTable = false }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const isSmallTable = onlySmallTable || isSmallScreen;

    return (
        <Table<MyBrokerApi.Activity, any>
            columns={isSmallTable ? activitiesTableMobileColumns : activitiesTableDesktopColumns}
            handleSort={handleSort}
            orderBy={orderBy}
            items={activities}
            renderItem={(activity: MyBrokerApi.Activity, index: number) => {
                const key = JSON.stringify({
                    ...activity,
                    key: index,
                });

                return isSmallTable ? (
                    <ActivitiesTableItemMobile activity={activity} key={key} />
                ) : (
                    <ActivitiesTableItemDesktop activity={activity} key={key} />
                );
            }}
        />
    );
};

export default ActivitiesTable;
